import { action, makeObservable, observable } from 'mobx'

class ProductOptionStore {
  uuid
  @observable key
  @observable value
  @observable protected = true

  constructor (data = {}) {
    makeObservable(this)
    Object.assign(this, data)
  }

  @action.bound
  setKey (value) {
    this.key = value
  }
}

export default ProductOptionStore
